import { ErrorLogComponent } from '@cian/error-log-component';
import { UiKitRoot } from '@cian/ui-kit';
import * as React from 'react';
import { Provider } from 'react-redux';
import '../../assets/colors/colors.css';

import { IApplicationContext } from '../../types/applicationContext';
import { IReduxStore } from '../../types/redux';
import { ApplicationContext } from '../../utils/applicationContext';
import { PageContainer } from '../Page';
import { CookieConsentContainer } from '../CookieConsent';
import { NoSsr } from '@cian/react-utils';

export interface IApplicationProps {
  context: IApplicationContext;
  reduxStore: IReduxStore;
}

export const Application: React.FC<IApplicationProps> = ({ reduxStore, context }) => {
  const {
    logger,
    custom: { initialDeviceType },
  } = context;

  return (
    <ErrorLogComponent logger={logger}>
      <ApplicationContext.Provider value={context}>
        <UiKitRoot deviceType={initialDeviceType}>
          <Provider store={reduxStore}>
            <PageContainer />
            <NoSsr>
              <CookieConsentContainer />
            </NoSsr>
          </Provider>
        </UiKitRoot>
      </ApplicationContext.Provider>
    </ErrorLogComponent>
  );
};
